module.exports = __webpack_public_path__ + "static/media/internet.14768c15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/internet.jpg
// module id = 380
// module chunks = 0